import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

const ContractTitle = ({ data }) => (
  <Typography
    variant="heading1"
    color="black.default"
    marginBottom="12x"
    marginLeft={{ xs: '0', lg: '-16x' }}
  >
    {data}
  </Typography>
);

ContractTitle.propTypes = {
  data: PropTypes.string.isRequired,
};

export default ContractTitle;
